
<script setup lang="ts">
import { Button } from '@albank/vue-ui-kit';
import { inject, onMounted, onUnmounted, ref, watch } from 'vue';

const scrolled = ref(0)
const scrollTop = ref(0)

const dark = ref<HTMLElement>()
const light = ref<HTMLElement>()
const themes = ref<HTMLElement>()

const active = ref<boolean>(true)
const scrollListener = ref<(e: WheelEvent) => any>()

const mobileOS: {
  url: string,
  name: string,
} = inject("isMobileOS", {
  url: '',
  name: ''
})

onMounted(() => {
  const body = document.documentElement || document.body
  const scrollPosition = themes.value?.offsetTop
  let lastScroll = scrollY || body.scrollTop;

  scrollTop.value = window.scrollY;

  scrollListener.value = () => {
    if (!scrollPosition) {
      return
    } 
    const currentScroll = body.scrollTop
    const isInArea = currentScroll > scrollPosition && active.value && currentScroll < scrollPosition + 200 

    if (isInArea && lastScroll < currentScroll) {
      themes.value?.classList.add('sticky')
      goDark()
    } else if (currentScroll + 200 < scrollPosition && !active.value) {
      active.value = true
    }

    lastScroll = currentScroll;
  }

  const endParallax = () => {
    scrolled.value = 0;
    themes.value?.classList.remove("fixed");
    body.classList.remove("infinite-height");
    body.scrollTo({top: scrollPosition});
    document.removeEventListener("scroll", parallax);
    scrollTop.value = window.scrollY;
  }

  const getClipPath = () => {
    const scrollDown = scrollTop.value < window.scrollY;
    scrollTop.value = window.scrollY;
    if (scrolled.value > 250 || scrolled.value < 0) {
      endParallax()
    }
    
    let value = 0;
    if (scrolled.value < 100) {
      value = 100 - scrolled.value
    } else if (scrolled.value > 150) {
      value = scrolled.value - 150
    }
    
    scrolled.value += scrollDown? 2: -2;
    return `polygon(0 ${value}%, 100% ${value}%, 100% 100%, 0% 100%)`
  }

  const parallax = () => {
    if (!dark.value) {
      return
    }
    
    const clipPath = getClipPath()
    dark.value.style.clipPath = clipPath
  }
  
  const goDark = () => {
    active.value = false
    light.value?.scrollIntoView({block: 'center'})

    setTimeout(() => {
      themes.value?.classList.add("fixed");
      body.classList.add("infinite-height");
      window.scrollTo({top: 45000});

      document.addEventListener("scroll", parallax)
    }, 300)
  }

  watch(active, () => {
    setTimeout(() => {
      if (active.value) {
        themes.value?.classList.add("sticky");
      } else {
        themes.value?.classList.remove("sticky");
      }
    }, 400)
  })

  setTimeout(() => {
    document.addEventListener("scroll", scrollListener.value as () => void, { passive:false })
  }, 1000)
})

onUnmounted(() => {
  document.removeEventListener("scroll", scrollListener.value as () => void)
})

</script>

<template>
  <section ref="themes" class="themes screen">
    <div ref="light" class="light-theme">
      <h2>Тёмная тема</h2>
      <p>Уменьшит нагрузку на глаза при тёмном освещении</p>
      <a :href="mobileOS?.name? mobileOS.url: 'https://www.rustore.ru/catalog/app/ru.albank.online.aebit'">
        <Button 
          class="dark-button button"
        >Скачать</Button>  
      </a>
      <img alt="app" src="/assets/images/light-theme.png" />
    </div>
    <div ref="dark" class="dark-theme">
      <h2>Тёмная тема</h2>
      <p>Уменьшит нагрузку на глаза при тёмном освещении</p>
      
      <a :href="mobileOS?.name? mobileOS.url: 'https://www.rustore.ru/catalog/app/ru.albank.online.aebit'">
        <Button 
          class="light-button button"  
        >Скачать</Button>  
      </a>
      <img alt="app" src="/assets/images/dark-theme.png" />
    </div>
  </section>
</template>


<style lang="scss">
.themes {
  top: 0;
  z-index: 10;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  background: var(--color-mono-0);
}

.sticky {
  position: sticky;
  align-self: flex-start;
}

.light-theme, .dark-theme {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  h2 {
    margin-top: 50px;
  }

  p {
    padding: 0 10%;
    margin-top: 16px;
    text-align: center;
    font-size: var( --font-size-md);
  }

  .button {
    z-index: 2;
    border: none;
    outline: none;  
    padding: 12px 60px;
    transform: translateY(100%);
  }

  img {
    width: 80vw;
    max-width: 620px;
    @media screen and (max-width: 800px) {
      width: 100%;
      margin-top: 52px;
    }
  }
}

.dark-theme {
  top: 0;
  z-index: 20;
  position: absolute;
  background: #161C26;  
  clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0% 100%);

  h2 {
    color: var(--color-mono-0);
  }

  p {
    color: #788290;
  }
}

.fixed {
  top: 0;
  position: fixed;
}
</style>
